<template>
<div class="container-fluid">
	<div class="row">
	    <div class="col-12">
			<h1>Add User</h1>
		</div>
	</div>

		<form @submit.prevent="submitForm" @keydown="form.onKeydown($event)" @change="form.onKeydown($event)" class="mb-0">
			<alert-errors v-if="form.length" :form="form">There were some problems with your input.</alert-errors>

		<div class="row">
			<div class="col-lg-6 col-12">
				<div class="card">
					<div class="card-header">Profile</div>
					<div class="card-body row">
						<div class="col-md-auto">
							<file-field
								ref="image"
								default_url="/images/avatars/default.png"							
								@file_changed="changedImage($event)"
							/>
					    </div>
						<div class="col">				
						    <div class="form-group">
								<label class="mb-0">First Name</label>
								<input class="form-control" v-model="form.first_name" required data-test="userFirstName">
						    </div>
						    <div class="form-group">
								<label class="mb-0">Last Name</label>
								<input class="form-control" v-model="form.last_name" required data-test="userLastName">
						    </div>
						    
						    <div class="form-group">
							    <label class="mb-0">Email</label>
							    <input class="form-control" v-model="form.email" type="email" autocomplete="off" data-lpignore="true" required data-test="userEmail">
						    </div>							    
						</div>
					</div>
				</div>
			</div>

			<div class="col-lg-6 col-12">
				<div class="card">
					<div class="card-header"><strong>Settings</strong></div>
					<div class="card-body">
						<div class="form-group">
							<label class="mb-0">Method</label>
							<select class="form-control" v-model="form_type" data-test="userCreateMethod">
								<option value="invite">Invite user via email</option>
								<option v-if="perms.can_do_everything" value="create">Create user manually</option>
							</select>
						</div>

						<template v-if="form_type === 'create'">
							<div class="form-group">
								<label class="mb-0">Password</label>
								<input class="form-control" v-model="form.password" type="password" required data-test="userPassword">
							</div>

							<div class="form-group">
								<label class="mb-0">Confirm</label>
								<input class="form-control" v-model="form.password_confirmation" type="password" required data-test="userPasswordConfirmation">
							</div>
						</template>

					    <div class="form-group">
						    Clients:
						    <div v-for="client in all_clients" class="form-check" data-test="userClients">
						    	<input type="checkbox" class="form-check-input" :value="client.id" v-model="form.client_list">
						    	<label class="form-check-label">{{ client.name }}</label>
							</div>
						</div>

					 	<div v-if="perms.can_assign_user_role" class="form-group mb-0" data-test="userRoles">
							<label class="mb-0">Roles - <span class="text-gray-500">Assign roles carefully!</span></label>
							<div v-for="role in all_roles" class="form-check" :data-test="'role ' + role.name">
								<input type="checkbox" class="form-check-input" :value="role.id" v-model="form.user_roles">
								<label class="form-check-label">{{ role.name }}</label>
							</div>
					    </div>
					</div>
				</div>
			</div>

			<div class="col-12">
				<div class="form-group">
					<span class="btn btn-ghost-secondary mr-1" @click="cancelEdit()">Cancel</span>
			    	<button type="submit" class="btn btn-primary" data-test="saveUserButton" :disabled="!formReady">Create User</button>
				</div>
			</div>
		</div>
		</form>	
	</div>
</div>
</template>

<script>
	import { mapState } from 'vuex';
    import BreadcrumbsManager from '../../helpers/BreadcrumbManager';
	import { Form, HasError, AlertError, AlertErrors, AlertSuccess } from 'vform';
	import { objectToFormData } from 'object-to-formdata'

	export default {
		mixins: [BreadcrumbsManager],

		data() {
			return {
				form_type: 'invite',
				all_clients: null,
				all_roles: null,
				form: {},
			}
		},

		created() {

		},

        activated() {
			this.fillForm();
			this.fetchClientIds();
			this.fetchRoles();			

            this.setBreadcrumbs([
                { text: 'Home', to: { name: 'home' } },
                { text: 'Users', to: { name: 'users.index'} },
                { text: 'Create User', to: { name: 'users.create'} },
            ]);  
        },

		methods: {
			cancelEdit() {
				this.$router.go(-1);
			},

			changedImage($event) {
				this.form.image = this.$refs.image.file;
			},

			createUser() {
				this.form.submit('post', '/api/admin/users/store', {
					transformRequest: [function (data, headers) {
						return objectToFormData(data)
					}],
				}).then(({ data }) => {
					Swal.fire({
						toast: true,
						position: 'top-end',
						showConfirmButton: false,
						timer: 4000,
						icon: 'success',
						title: 'User created',
					});
					//this.form = {};
					this.$router.push({ name: 'users.index' });
				});
			},

            fetchClientIds() {
            	//if (this.perms.can_do_everything) {
					axios.get('/api/admin/clients/ids').then(({data}) => {
						this.all_clients = data;
					});
				//}
            },

            fetchRoles() {
            	if (this.perms.can_do_everything || this.perms.can_assign_user_role) {
					axios.get('/api/roles/available').then(({data}) => {
						this.all_roles = data;
					});
				}
            },

            fillForm() {
            	this.form = new Form({
					first_name: null,
					last_name: null,
					email: null,
					image: null,
					user_roles: [],
					client_list: [],
					status: this.form_type == 'create' ? 1 : 0,
				});

            	//auto-set to proper client for non-admins
				// if (!this.perms.can_do_everything) {
				// 	this.form.client_list = [this.user.client_id];
				// }
            },

            inviteUser() {
				this.form.submit('post', '/api/admin/users/invite', {
					transformRequest: [function (data, headers) {
						return objectToFormData(data)
					}],
				}).then(({ data }) => {
					Swal.fire({
						toast: true,
						position: 'top-end',
						showConfirmButton: false,
						timer: 4000,
						icon: 'success',
						title: 'User invited',
					});
					//this.form = {};
					this.$router.push({ name: 'users.index' });
				});            	
            },

        	submitForm() { 
        		if (this.form_type === 'create' && this.perms.can_do_everything) {
        			this.createUser();
        		}
        		else {
        			this.inviteUser();
        		}       		
        	},
		},

		watch: {
			form_type() {
				if (this.form_type === 'create') {
					this.form.password = null;
					this.form.password_confirmation = null;
				}
				if (this.form_type === 'invite') {
					delete this.form.password;
					delete this.form.password_confirmation;
				}
			}
		},

		computed: {
			...mapState(['perms', 'user']),
			formReady() {
				return this.form.first_name && this.form.last_name && this.form.email && this.form.user_roles.length > 0 && this.form.client_list.length > 0;
			}
		}
	}
</script>